import React from "react";

import Image from "assets/images/auth/auth-bg.png";
import dots from "assets/images/auth/dots.svg";
import Ellipse1 from "assets/images/auth/ellipse-1.svg";
import Ellipse3 from "assets/images/auth/ellipse-3.svg";
import KinesinLogo from "assets/images/auth/kinesin-logo.svg";
import { AppVersion } from "components/AppVersion/AppVersion";

import s from "./AuthLayout.module.css";

// Pages that need the version somewhere else (e.g. below a tall form) pass
// showVersion={false} and render <AppVersion /> themselves.
const AuthLayout = ({ children, showVersion = true }) => {
  return (
    <div className={s.container}>
      <div className={s.contentContainer}>
        <img className={s.logo} src={KinesinLogo} alt="Kinesin logo" />

        <img src={Ellipse1} alt="Green ellipse" className={s.ellipse1} />
        <img src={Ellipse3} alt="Green ellipse" className={s.ellipse3} />
        <img src={dots} alt="Green dots" className={s.dots} />

        <div className={s.content}>{children}</div>

        {showVersion && <AppVersion className={s.versionData} />}
      </div>
      <div className={s.rightContainer}>
        <img src={Image} alt="Doctor" className={s.rightBgImage} />
      </div>
    </div>
  );
};

export { AuthLayout };